import { render, staticRenderFns } from "./header-notifications.vue?vue&type=template&id=49959030&scoped=true&"
import script from "../../js/widgets/header-notifications.js?vue&type=script&lang=js&"
export * from "../../js/widgets/header-notifications.js?vue&type=script&lang=js&"
import style0 from "./header-notifications.vue?vue&type=style&index=0&id=49959030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49959030",
  null
  
)

export default component.exports